import { render, staticRenderFns } from "./ReadyFightSection.vue?vue&type=template&id=15be5d5f&scoped=true"
import script from "./ReadyFightSection.vue?vue&type=script&lang=js"
export * from "./ReadyFightSection.vue?vue&type=script&lang=js"
import style0 from "./ReadyFightSection.vue?vue&type=style&index=0&id=15be5d5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15be5d5f",
  null
  
)

export default component.exports